import React, { useState } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { toast } from 'react-toastify';
import FormatUrl from '../../utils/UrlFormatter';

const SaveCardButton = ({ user, clinicId, onCardSaved }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);

  const handleSaveCard = async () => {
    if (!stripe || !elements) {
      toast.error("Stripe not loaded yet");
      return;
    }

    setLoading(true);

    try {
      const csrfRes = await fetch(FormatUrl(`/csrf-token/`), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
      const { csrfToken } = await csrfRes.json();

      // Create Stripe payment method
      const cardElement = elements.getElement(CardElement);
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });

      if (error) {
        toast.error(error.message || "Failed to create payment method");
        setLoading(false);
        return;
      }

      const payload = {
        profile_id: user?.profile_id,
        clinic_id: clinicId,
        payment_method_id: paymentMethod.id,
        currency: "cad",
      };

      const response = await fetch(FormatUrl(`/payments/tokenize-card/`), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to save card');
      }

      toast.success('Card saved successfully ✅');

      // ✅ Clear the CardElement input after saving
      if (cardElement) {
        cardElement.clear();
      }

      // ✅ Trigger parent refetch
      if (onCardSaved) {
        onCardSaved();
      }

    } catch (err) {
      toast.error(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className="save-card-button"
      onClick={handleSaveCard}
      disabled={loading}
    >
      {loading ? 'Saving...' : 'Save Card'}
    </button>
  );
};

export default SaveCardButton;
